import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ProductVideo } from '@/modules/components';
import { IndexType } from '@/type';
import { useInteractionState } from '@/hooks';

export const MediaComponent = () => {
  const { management } = useInteractionState();
  const media =
    management?.mediaDocument?.entity_type === IndexType.MEDIA
      ? management?.mediaDocument
      : undefined;

  const videoSources = media
    ? {
        src: media.path,
        type: media.type,
      }
    : undefined;

  return (
    <section id="media" className="description_content">
      <div className="text-content container transparent">
        <div className="col-md-1" />
        <div className="col-md-10">
          <h1>
            <FormattedMessage id="app.media.cook.style" />
          </h1>
          {videoSources && (
            <div>
              <ProductVideo sources={videoSources} />
            </div>
          )}
        </div>
        <div className="col-md-1" />
      </div>
    </section>
  );
};
